import { makeStyles } from '@material-ui/core/styles';

export const useQuizResultStyles = makeStyles((theme) => ({
  alignment: {
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
    },
    '&.MuiTypography-paragraph': {
      marginBottom: 0,
    },
  },
  alignmentCenter: {
    [theme.breakpoints.up('md')]: {
      textAlign: 'center',
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
  },
  cardContent: {
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
      '&:last-child': {
        paddingBottom: theme.spacing(3),
      },
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(4),
      '&:last-child': {
        paddingBottom: theme.spacing(4),
      },
    },
  },
  cardContentIsModal: {
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
      '&:last-child': {
        paddingBottom: theme.spacing(3),
      },
    },
  },
  container: {
    height: '100%',
  },
  img: {
    display: 'block',
    height: 'auto',
    margin: '0 auto',
    maxHeight: '100px',
    maxWidth: '100%',
    [theme.breakpoints.up('md')]: {
      maxHeight: '200px',
    },
  },
  imgCenter: {
    [theme.breakpoints.up('md')]: {
      maxHeight: '100px',
    },
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  reversed: {
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row-reverse',
    },
  },
}));
